<template>
  <v-card>
    <v-row align="center" v-loading="loading">
      <v-card-icon :icon="icon"></v-card-icon>
      <v-card-body :modifiers="bodyModifiers">
        <slot />
      </v-card-body>
    </v-row>
  </v-card>
</template>

<script>
import VCard from '@/components/common/VCard.vue'
import VCardIcon from '@/components/common/VCardIcon.vue'
import VCardBody from '@/components/common/VCardBody.vue'
import VRow from '@/components/common/VRow.vue'

export default {
  name: 'VNotificationCard',
  components: {
    VCard,
    VCardIcon,
    VCardBody,
    VRow
  },
  props: {
    icon: { type: String, required: true },
    contentRightIndent: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  computed: {
    bodyModifiers() {
      const modifiers = ['gray']
      return this.contentRightIndent
        ? [...modifiers, 'right-indent']
        : modifiers
    }
  }
}
</script>
